import React from 'react'

const SearchIcon = ({ height = 32, width = 32, lightGray, gray }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 32 32"
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 32h32V0H0z" />
        <g
          stroke={lightGray ? '#D0D1DC' : gray ? '#A1A9B4' : '#29313E'}
          strokeWidth="2"
        >
          <path d="M14.15 6.57a7.003 7.003 0 1 0 0 14.005 7.003 7.003 0 0 0 0-14.005z" />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M18.724 18.902l5.728 5.728"
          />
        </g>
      </g>
    </svg>
  )
}

export default SearchIcon
